<template>
  <ButtonBase
    :disabled="disabled"
    :class="{ 'large-border': largeBorder }"
    class="button form"
    stroke="n"
    rounded
    :size="size"
    theme="secondary"
    :type="type"
    v-bind="props"
  >
    <IconToggle
      :is-on="loading"
      :icon-name-off="iconNameOff"
      :icon-name-on="iconNameOn"
      :icon-size="iconSize"
    />

    <slot />
  </ButtonBase>
</template>
<script setup lang="ts">
interface Props {
  size?: 'small' | 'medium';
  theme?: string;
  disabled?: boolean;
  loading?: boolean;
  iconNameOff?: string;
  iconNameOn?: string;
  iconSize?: string;
  largeBorder?: boolean;
  type?: 'button' | 'submit' | 'reset';
}
const props = defineProps({
  size: { default: 'medium' },
  theme: { default: 'secondary' },
  disabled: { type: Boolean, default: false },
  loading: { type: Boolean },
  iconNameOff: { default: 'quizQuestionSubmit' },
  iconNameOn: { default: 'loading' },
  iconSize: { default: '2.6rem' },
  largeBorder: { type: Boolean, default: true },
  type: { default: 'submit' }
});
</script>
<style lang="scss" scoped>
.button.form {
  &.large-border {
    border-width: var(--stroke_thickness_l);
  }

  :deep(.button-base-content) {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: var(--gap_xs);
  }
  svg + svg {
    // fix bug having duplicate svg when reloading page ...
    display: none;
  }
}
</style>
